/*@ngInject*/
const GetAccountsByFilterUriRepository = function (baseRepository, sortUtil) {

    angular.extend(this, baseRepository);

    this.getAccountsByFilterUri = function (filterUri, requestParams) {
        let url = '/rest/Account/filter',
            data = {
                filterUri: filterUri,
                sortBy: 'name',
                startIndex: 0,
                numberOfRows: -1,
                displayAllAccounts: true,
                includeSubmittedSubmissionAccounts: true,
                excludeCandidateAccounts: false,
                excludeInactiveAccounts: false,
                matchNameAndAddressOrAccountNumberOrIdentifier: true
            },
            sortColumn,
            accessors = _.split(requestParams.key, '::');
        if(accessors[0] !== 'identifiers' && accessors[0] !== 'aliases'){
            sortColumn = accessors[0];
        }

        return this.get(url, {params: data}).then(function (responseData) {
            if(!sortColumn){
                _.each(responseData.accountSummaries, function(account){
                    if(accessors[0] === 'aliases'){
                        sortColumn = 'aliasConcat';
                        //Gets all the alias names and then concatenates them together
                        account.aliasConcat = _.join(_.map(account.aliases, 'name'), ',');
                    }
                    if(accessors[0] === 'identifiers'){
                        sortColumn = 'identifiersConcat';
                        //Finds all the identifers of the right type, gets all of their values, and concatenates them together
                        let typedIdentifiers = _.filter(account.identifiers, ['type', accessors[1]]),
                            identifierValues = _.map(typedIdentifiers, 'identifier');
                        account.identifiersConcat = _.join(identifierValues, ',');
                    }
                });
            }
            let sortedRecords = responseData.accountSummaries.sort(sortUtil.naturalSortObject(sortColumn));

            if (requestParams.sortType === 'desc') {
                sortedRecords.reverse();
            }
            responseData.accountSummaries = sortedRecords;

            return responseData;
        });
    };
};

angular.module('gw-um-submission')
    .service('getAccountsByFilterUriRepository', GetAccountsByFilterUriRepository);
